import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, Teleport as _Teleport } from "vue";
const _hoisted_1 = {
  class: "list-page-table-panel list-page-table-panel--fill mx-6"
};
const _hoisted_2 = {
  class: "flex items-center justify-between"
};
const _hoisted_3 = {
  key: 0,
  class: "ml-2 text-xs text-slate-400"
};
const _hoisted_4 = {
  class: "data-table-shell"
};
const _hoisted_5 = {
  class: "data-table-scroll data-table-scroll--fill"
};
const _hoisted_6 = {
  class: "data-table text-sm min-w-[1280px]"
};
const _hoisted_7 = {
  class: "data-table-head"
};
const _hoisted_8 = {
  class: "data-table-th is-center w-10"
};
const _hoisted_9 = ["checked", "disabled"];
const _hoisted_10 = {
  key: 1
};
const _hoisted_11 = {
  class: "data-table-td is-center"
};
const _hoisted_12 = ["checked", "onChange"];
const _hoisted_13 = {
  class: "data-table-td"
};
const _hoisted_14 = {
  class: "font-mono text-slate-900 text-xs"
};
const _hoisted_15 = {
  class: "data-table-td"
};
const _hoisted_16 = {
  class: "flex items-center gap-2"
};
const _hoisted_17 = {
  class: "w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center text-xs font-medium text-primary-700"
};
const _hoisted_18 = {
  class: "text-sm text-slate-900"
};
const _hoisted_19 = {
  class: "text-xs text-slate-500"
};
const _hoisted_20 = {
  class: "data-table-td is-right"
};
const _hoisted_21 = {
  class: "money-text"
};
const _hoisted_22 = {
  class: "data-table-td is-center"
};
const _hoisted_23 = {
  class: "inline-flex items-center px-2 py-1 rounded-full status-badge is-neutral text-xs"
};
const _hoisted_24 = {
  class: "data-table-td"
};
const _hoisted_25 = {
  class: "data-table-td"
};
const _hoisted_26 = {
  class: "text-sm text-slate-900"
};
const _hoisted_27 = {
  class: "data-table-td"
};
const _hoisted_28 = {
  class: "data-table-td"
};
const _hoisted_29 = {
  key: 0,
  class: "max-w-[220px]"
};
const _hoisted_30 = {
  class: "text-xs text-red-600"
};
const _hoisted_31 = ["title"];
const _hoisted_32 = {
  key: 1,
  class: "text-slate-400"
};
const _hoisted_33 = {
  class: "data-table-td text-slate-600 text-xs"
};
const _hoisted_34 = {
  class: "data-table-td is-center data-table-sticky-right data-table-sticky-action"
};
const _hoisted_35 = {
  class: "flex items-center justify-center gap-1"
};
const _hoisted_36 = ["onClick"];
const _hoisted_37 = ["onClick"];
const _hoisted_38 = ["onClick"];
const _hoisted_39 = ["onClick"];
const _hoisted_40 = {
  key: 0,
  class: "sticky bottom-0 z-20 mt-3 flex flex-wrap items-center justify-between gap-3 rounded-xl border border-primary-200 bg-white px-4 py-3 shadow-lg"
};
const _hoisted_41 = {
  class: "flex items-center gap-3 text-sm"
};
const _hoisted_42 = {
  class: "font-medium text-slate-900"
};
const _hoisted_43 = {
  class: "text-slate-500"
};
const _hoisted_44 = {
  class: "money-text"
};
const _hoisted_45 = {
  class: "flex gap-2"
};
const _hoisted_46 = ["disabled"];
const _hoisted_47 = ["disabled"];
const _hoisted_48 = ["disabled"];
const _hoisted_49 = {
  class: "flex-shrink-0 flex items-center justify-between px-6 py-4 border-b border-slate-200"
};
const _hoisted_50 = {
  class: "flex-1 overflow-y-auto min-h-0 p-6 space-y-5"
};
const _hoisted_51 = {
  class: "grid grid-cols-1 md:grid-cols-4 gap-4"
};
const _hoisted_52 = {
  class: "flex items-center justify-between"
};
const _hoisted_53 = {
  key: 0,
  class: "ml-2 text-xs text-slate-400"
};
const _hoisted_54 = {
  class: "flex items-end"
};
const _hoisted_55 = {
  class: "bg-primary-50 rounded-xl p-4"
};
const _hoisted_56 = {
  class: "text-2xl font-semibold text-primary-700"
};
const _hoisted_57 = {
  class: "text-xs text-primary-600 mt-1"
};
const _hoisted_58 = {
  class: "border border-slate-200 rounded-xl overflow-hidden"
};
const _hoisted_59 = {
  class: "data-table text-sm"
};
const _hoisted_60 = {
  class: "data-table-head"
};
const _hoisted_61 = {
  class: "data-table-th text-left w-10"
};
const _hoisted_62 = ["checked"];
const _hoisted_63 = {
  key: 0
};
const _hoisted_64 = {
  key: 1
};
const _hoisted_65 = {
  class: "data-table-td is-center"
};
const _hoisted_66 = ["checked", "onChange"];
const _hoisted_67 = {
  class: "data-table-td"
};
const _hoisted_68 = {
  class: "font-mono text-xs text-slate-900"
};
const _hoisted_69 = {
  class: "text-xs text-slate-500"
};
const _hoisted_70 = {
  class: "data-table-td"
};
const _hoisted_71 = {
  class: "text-sm text-slate-900"
};
const _hoisted_72 = {
  class: "text-xs text-slate-500"
};
const _hoisted_73 = {
  class: "data-table-td is-right"
};
const _hoisted_74 = {
  class: "data-table-td is-right text-slate-600"
};
const _hoisted_75 = {
  class: "data-table-td is-right money-text"
};
const _hoisted_76 = {
  class: "data-table-td text-xs text-slate-600"
};
const _hoisted_77 = {
  class: "flex items-center justify-between"
};
const _hoisted_78 = ["disabled"];
const _hoisted_79 = {
  class: "text-sm text-slate-500"
};
const _hoisted_80 = ["disabled"];
const _hoisted_81 = {
  class: "flex-shrink-0 px-6 py-4 border-t border-slate-200 flex justify-end gap-3"
};
const _hoisted_82 = ["disabled"];
const _hoisted_83 = {
  class: "flex-shrink-0 flex items-center justify-between px-6 py-4 border-b border-slate-200"
};
const _hoisted_84 = {
  class: "text-sm text-slate-500 font-mono"
};
const _hoisted_85 = {
  class: "flex items-center gap-3"
};
const _hoisted_86 = {
  class: "flex-1 overflow-y-auto min-h-0 p-6 space-y-5"
};
const _hoisted_87 = {
  key: 0,
  class: "py-16 text-center text-slate-500"
};
const _hoisted_88 = {
  class: "grid grid-cols-2 md:grid-cols-5 gap-4"
};
const _hoisted_89 = {
  class: "bg-slate-50 rounded-xl p-4"
};
const _hoisted_90 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_91 = {
  class: "text-xs text-slate-500"
};
const _hoisted_92 = {
  class: "bg-slate-50 rounded-xl p-4"
};
const _hoisted_93 = {
  class: "text-lg money-text"
};
const _hoisted_94 = {
  class: "bg-slate-50 rounded-xl p-4"
};
const _hoisted_95 = {
  class: "text-lg font-semibold text-emerald-600"
};
const _hoisted_96 = {
  class: "bg-slate-50 rounded-xl p-4"
};
const _hoisted_97 = {
  class: "text-sm text-slate-900"
};
const _hoisted_98 = {
  class: "bg-slate-50 rounded-xl p-4"
};
const _hoisted_99 = {
  class: "text-sm text-slate-900"
};
const _hoisted_100 = {
  class: "bg-white border border-slate-200 rounded-xl overflow-hidden"
};
const _hoisted_101 = {
  class: "px-4 py-3 border-b border-slate-200"
};
const _hoisted_102 = {
  class: "flex items-center justify-between mb-3"
};
const _hoisted_103 = {
  class: "text-xs text-slate-500"
};
const _hoisted_104 = {
  class: "grid grid-cols-2 md:grid-cols-6 gap-2"
};
const _hoisted_105 = {
  class: "text-xs text-slate-500"
};
const _hoisted_106 = {
  class: "overflow-x-auto"
};
const _hoisted_107 = {
  class: "data-table text-sm"
};
const _hoisted_108 = {
  key: 0
};
const _hoisted_109 = {
  class: "data-table-td"
};
const _hoisted_110 = {
  class: "font-mono text-xs text-slate-900"
};
const _hoisted_111 = {
  class: "text-xs text-slate-500"
};
const _hoisted_112 = {
  class: "data-table-td"
};
const _hoisted_113 = {
  class: "data-table-td is-right"
};
const _hoisted_114 = {
  class: "data-table-td is-right"
};
const _hoisted_115 = {
  class: "data-table-td is-right money-text"
};
const _hoisted_116 = {
  class: "data-table-td"
};
const _hoisted_117 = {
  class: "flex items-center gap-1.5 min-w-[220px]"
};
const _hoisted_118 = {
  class: "flex flex-col items-center gap-1"
};
const _hoisted_119 = ["title"];
const _hoisted_120 = {
  class: "data-table-td"
};
const _hoisted_121 = {
  class: "data-table-td"
};
const _hoisted_122 = {
  class: "font-mono text-xs text-slate-900"
};
const _hoisted_123 = {
  class: "font-mono text-xs text-slate-500"
};
const _hoisted_124 = {
  class: "data-table-td"
};
const _hoisted_125 = {
  class: "data-table-td"
};
const _hoisted_126 = {
  key: 0,
  class: "max-w-[240px]"
};
const _hoisted_127 = {
  class: "text-xs text-red-600"
};
const _hoisted_128 = ["title"];
const _hoisted_129 = {
  key: 1,
  class: "text-slate-400"
};
const _hoisted_130 = {
  class: "data-table-td text-xs text-slate-600"
};
const _hoisted_131 = {
  class: "grid grid-cols-1 lg:grid-cols-2 gap-5"
};
const _hoisted_132 = {
  class: "bg-white border border-slate-200 rounded-xl p-4"
};
const _hoisted_133 = {
  key: 0,
  class: "text-sm text-slate-500"
};
const _hoisted_134 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_135 = {
  class: "text-xs text-slate-500"
};
const _hoisted_136 = {
  class: "text-xs text-slate-400 mt-1"
};
const _hoisted_137 = {
  class: "bg-white border border-slate-200 rounded-xl p-4"
};
const _hoisted_138 = {
  key: 0,
  class: "text-sm text-slate-500"
};
const _hoisted_139 = {
  class: "text-sm text-slate-900"
};
const _hoisted_140 = {
  class: "text-xs text-slate-500"
};
const _hoisted_141 = {
  class: "text-right"
};
const _hoisted_142 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_143 = {
  class: "text-xs text-slate-400"
};
const _hoisted_144 = {
  key: 0,
  class: "bg-slate-50 rounded-xl p-4"
};
const _hoisted_145 = {
  class: "grid grid-cols-1 md:grid-cols-3 gap-4 text-sm"
};
const _hoisted_146 = {
  key: 0
};
const _hoisted_147 = {
  class: "text-slate-900"
};
const _hoisted_148 = {
  key: 1
};
const _hoisted_149 = {
  class: "text-red-600"
};
const _hoisted_150 = {
  key: 2
};
const _hoisted_151 = {
  class: "text-slate-900"
};
const _hoisted_152 = {
  class: "flex-shrink-0 px-6 py-4 border-t border-slate-200 flex justify-end gap-3"
};
const _hoisted_153 = {
  class: "flex items-center justify-between px-6 py-4 border-b border-slate-200"
};
const _hoisted_154 = {
  class: "p-6"
};
const _hoisted_155 = {
  class: "px-6 py-4 border-t border-slate-200 flex justify-end gap-3"
};
const _hoisted_156 = {
  class: "flex items-center justify-between px-6 py-4 border-b border-slate-200"
};
const _hoisted_157 = {
  class: "p-6"
};
const _hoisted_158 = {
  class: "mb-3 text-sm text-slate-500"
};
const _hoisted_159 = {
  class: "px-6 py-4 border-t border-slate-200 flex justify-end gap-3"
};
const _hoisted_160 = ["disabled"];
const _hoisted_161 = ["disabled"];
const _hoisted_162 = {
  class: "flex items-center justify-between px-6 py-4 border-b border-slate-200"
};
const _hoisted_163 = {
  class: "text-sm text-slate-500 font-mono"
};
const _hoisted_164 = {
  class: "p-6 space-y-4"
};
const _hoisted_165 = {
  class: "rounded-xl bg-amber-50 border border-amber-200 p-4 text-sm text-amber-800 space-y-1"
};
const _hoisted_166 = {
  class: "px-6 py-4 border-t border-slate-200 flex justify-end gap-3"
};
import { ref, reactive, computed, onMounted } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import AppPagination from '@/components/AppPagination.vue';
import ListPageShell from '@/components/ListPageShell.vue';
import PageFilterBar from '@/components/PageFilterBar.vue';
import AppModal from '@/components/AppModal.vue';
import { getWithdrawOrderList, getWithdrawOrderFullDetail, listAvailableWithdrawDetails, createWithdrawByDetails, auditWithdraw, completeManualWithdraw, handleWithdrawTimeoutOrders } from '@/api/commission';
import { getReferrerPage } from '@/api/referrer';
export default {
  __name: 'WithdrawalManagement',
  setup(__props) {
    const statusMap = {
      0: {
        label: '待审核',
        class: 'status-badge is-warning',
        dot: 'bg-amber-500'
      },
      1: {
        label: '待执行',
        class: 'status-badge is-info',
        dot: 'bg-blue-500'
      },
      2: {
        label: '处理中',
        class: 'status-badge is-indigo',
        dot: 'bg-indigo-500'
      },
      3: {
        label: '已到账',
        class: 'status-badge is-success',
        dot: 'bg-emerald-500'
      },
      4: {
        label: '已驳回',
        class: 'status-badge is-neutral',
        dot: 'bg-slate-500'
      },
      5: {
        label: '失败',
        class: 'status-badge is-danger',
        dot: 'bg-red-500'
      },
      default: {
        label: '未知',
        class: 'status-badge is-neutral',
        dot: 'bg-slate-400'
      }
    };
    const manualHandleMap = {
      0: {
        label: '无需处理',
        class: 'status-badge is-neutral'
      },
      1: {
        label: '待人工处理',
        class: 'status-badge is-danger'
      },
      2: {
        label: '已人工处理',
        class: 'status-badge is-success'
      },
      default: {
        label: '无需处理',
        class: 'status-badge is-neutral'
      }
    };
    const channelStatusMap = {
      PENDING_AUDIT: '待审核',
      WAIT_EXECUTE: '待执行',
      'SEPARATE.PROCESSING': '分账处理中',
      'SEPARATE.FAILED': '分账失败',
      'WITHDRAW.PROCESSING': '提现处理中',
      'WITHDRAW.FAILED': '提现失败',
      SUCCESS: '成功'
    };
    const filters = reactive({
      status: undefined,
      manualHandleStatus: undefined,
      referrerId: undefined,
      dateRange: null
    });
    const referrerOptions = ref([]);
    const referrerLoading = ref(false);
    async function searchReferrers(keyword) {
      referrerLoading.value = true;
      try {
        const data = await getReferrerPage({
          name: keyword || undefined,
          status: 1,
          page: 1,
          size: 20
        });
        referrerOptions.value = data.records || [];
      } catch {
        referrerOptions.value = [];
      } finally {
        referrerLoading.value = false;
      }
    }
    const tableData = ref([]);
    const loading = ref(false);
    const total = ref(0);
    const pagination = reactive({
      current: 1,
      size: 10,
      pages: 1
    });
    const createDialogVisible = ref(false);
    const availableLoading = ref(false);
    const availableDetails = ref([]);
    const availableTotal = ref(0);
    const availablePagination = reactive({
      current: 1,
      size: 10
    });
    const createForm = reactive({
      referrerId: '',
      keyword: '',
      selectedDetails: {},
      remark: '',
      requireAudit: true
    });
    const detailDialogVisible = ref(false);
    const detailLoading = ref(false);
    const currentRow = ref(null);
    const showRejectInput = ref(false);
    const rejectReason = ref('');
    const selectedIds = ref(new Set());
    const batchRunning = ref(false);
    const batchRejectVisible = ref(false);
    const batchRejectReason = ref('');
    const eligibleRows = computed(() => tableData.value.filter(row => row.status === 0));
    const selectedCount = computed(() => selectedIds.value.size);
    const allEligibleSelected = computed(() => eligibleRows.value.length > 0 && eligibleRows.value.every(row => selectedIds.value.has(row.id)));
    const selectedTotalAmount = computed(() => tableData.value.filter(row => selectedIds.value.has(row.id)).reduce((sum, row) => sum + (Number(row.amount) || 0), 0));
    function toggleRowSelection(row) {
      const next = new Set(selectedIds.value);
      if (next.has(row.id)) next.delete(row.id);else next.add(row.id);
      selectedIds.value = next;
    }
    function toggleSelectAll() {
      selectedIds.value = allEligibleSelected.value ? new Set() : new Set(eligibleRows.value.map(row => row.id));
    }
    function clearSelection() {
      selectedIds.value = new Set();
    }
    function pruneSelection() {
      const eligible = new Set(eligibleRows.value.map(row => row.id));
      selectedIds.value = new Set([...selectedIds.value].filter(id => eligible.has(id)));
    }
    const manualDialogVisible = ref(false);
    const manualRow = ref(null);
    const manualRemark = ref('');
    const selectedCreateList = computed(() => Object.values(createForm.selectedDetails));
    const selectedCreateIds = computed(() => selectedCreateList.value.map(item => item.commissionDetailId));
    const selectedCreateAmount = computed(() => selectedCreateList.value.reduce((sum, item) => sum + toNumber(item.withdrawableAmount), 0));
    const canSubmitCreate = computed(() => Number(createForm.referrerId) > 0 && selectedCreateIds.value.length > 0 && selectedCreateAmount.value > 0);
    const allAvailableSelected = computed(() => availableDetails.value.length > 0 && availableDetails.value.every(item => isCreateSelected(item.commissionDetailId)));
    const sourceStatusSummary = computed(() => {
      const details = currentRow.value?.sourceDetails || [];
      return [{
        label: '账单总数',
        count: details.length,
        class: 'text-slate-900'
      }, {
        label: '分账成功',
        count: details.filter(item => item.separateStatus === 2).length,
        class: 'text-emerald-600'
      }, {
        label: '分账失败',
        count: details.filter(item => item.separateStatus === 3).length,
        class: 'text-red-600'
      }, {
        label: '提现成功',
        count: details.filter(item => item.withdrawStatus === 3).length,
        class: 'text-emerald-600'
      }, {
        label: '提现失败',
        count: details.filter(item => item.withdrawStatus === 4).length,
        class: 'text-red-600'
      }, {
        label: '待处理',
        count: details.filter(item => [0, 1, 2].includes(item.withdrawStatus)).length,
        class: 'text-amber-600'
      }];
    });
    const manualRiskTips = computed(() => {
      const details = manualRow.value?.sourceDetails || currentRow.value?.sourceDetails || [];
      const tips = [];
      if (details.some(item => item.separateStatus === 3)) {
        tips.push('存在分账失败账单：请优先确认是否需要重试分账或释放账单占用，不建议直接标记提现完成。');
      }
      if (details.some(item => item.separateStatus === 2 && item.withdrawStatus === 4)) {
        tips.push('存在分账成功但提现失败账单：请确认是否已线下打款，避免重复出款。');
      }
      if (details.some(item => item.withdrawStatus === 3) && details.some(item => item.withdrawStatus !== 3)) {
        tips.push('存在部分提现成功账单：人工完成前请核对已到账明细和未完成明细。');
      }
      if (!tips.length) {
        tips.push('请先确认失败阶段和线下处理结果，再完成人工处理。');
      }
      return tips;
    });
    function toNumber(value) {
      if (value === null || value === undefined || value === '') return 0;
      const num = Number(value);
      return Number.isFinite(num) ? num : 0;
    }
    function formatAmount(value) {
      return toNumber(value).toLocaleString('zh-CN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }
    function displayWithdrawStatusName(detail) {
      if (detail.withdrawStatus === 0 || detail.withdrawStatusName === '已占用') {
        return '已锁定';
      }
      return detail.withdrawStatusName || '-';
    }
    function getBillProgressSteps(detail) {
      return [{
        key: 'locked',
        label: '锁定',
        status: detail.withdrawStatus === 5 ? 'skipped' : 'done',
        tip: '账单已被当前提现单锁定'
      }, {
        key: 'separate',
        label: '分账',
        status: resolveSeparateProgressStatus(detail),
        tip: detail.failStage === 'SEPARATE_SUBMIT' || detail.failStage === 'SEPARATE_RESULT' ? detail.failReason || '分账失败' : detail.separateStatusName || '分账状态'
      }, {
        key: 'withdraw',
        label: '提现',
        status: resolveWithdrawProgressStatus(detail),
        tip: detail.failStage === 'WITHDRAW_SUBMIT' || detail.failStage === 'WITHDRAW_RESULT' ? detail.failReason || '提现失败' : displayWithdrawStatusName(detail)
      }, {
        key: 'finish',
        label: '完成',
        status: detail.withdrawStatus === 3 ? 'done' : detail.withdrawStatus === 4 ? 'failed' : 'pending',
        tip: detail.withdrawStatus === 3 ? '提现成功' : detail.withdrawStatus === 4 ? detail.failReason || '提现失败' : '等待完成'
      }];
    }
    function resolveSeparateProgressStatus(detail) {
      if (detail.separateStatus === 2 || detail.separateStatus === 4) return 'done';
      if (detail.separateStatus === 3) return 'failed';
      if (detail.separateStatus === 1) return 'processing';
      return 'pending';
    }
    function resolveWithdrawProgressStatus(detail) {
      if (detail.withdrawStatus === 3) return 'done';
      if (detail.withdrawStatus === 4) return 'failed';
      if (detail.withdrawStatus === 2) return 'processing';
      if (detail.withdrawStatus === 1) return 'pending';
      return 'pending';
    }
    function getBillProgressStepClass(status) {
      const map = {
        done: 'bg-emerald-50 text-emerald-700 border-emerald-300',
        processing: 'bg-blue-50 text-blue-700 border-blue-300',
        failed: 'bg-red-50 text-red-700 border-red-300',
        skipped: 'bg-slate-50 text-slate-500 border-slate-300',
        pending: 'bg-slate-50 text-slate-500 border-slate-200'
      };
      return map[status] || map.pending;
    }
    function getBillProgressTextClass(status) {
      const map = {
        done: 'text-emerald-700',
        processing: 'text-blue-700',
        failed: 'text-red-700',
        skipped: 'text-slate-500',
        pending: 'text-slate-500'
      };
      return map[status] || map.pending;
    }
    function toDateTimeStart(date) {
      return date ? `${date} 00:00:00` : undefined;
    }
    function toDateTimeEnd(date) {
      return date ? `${date} 23:59:59` : undefined;
    }
    async function fetchWithdrawalList() {
      loading.value = true;
      try {
        const params = {
          pageNum: pagination.current,
          pageSize: pagination.size,
          referrerId: filters.referrerId ? Number(filters.referrerId) : undefined,
          status: filters.status,
          manualHandleStatus: filters.manualHandleStatus,
          startDate: toDateTimeStart(filters.dateRange?.[0]),
          endDate: toDateTimeEnd(filters.dateRange?.[1])
        };
        const res = await getWithdrawOrderList(params);
        tableData.value = res.records || [];
        total.value = res.total || 0;
        pagination.pages = res.pages || Math.max(1, Math.ceil(total.value / pagination.size));
        pruneSelection();
      } catch (error) {
        ElMessage.error('获取提现列表失败');
        console.error(error);
      } finally {
        loading.value = false;
      }
    }
    function handleSearch() {
      pagination.current = 1;
      fetchWithdrawalList();
    }
    function handleReset() {
      filters.status = undefined;
      filters.manualHandleStatus = undefined;
      filters.referrerId = undefined;
      filters.dateRange = null;
      handleSearch();
    }
    function handlePageChange(page) {
      if (page < 1 || page > pagination.pages) return;
      pagination.current = page;
      fetchWithdrawalList();
    }
    function handlePageSizeChange(size) {
      pagination.size = size;
      pagination.current = 1;
      fetchWithdrawalList();
    }
    function handleCreate() {
      createForm.referrerId = '';
      createForm.keyword = '';
      createForm.selectedDetails = {};
      createForm.remark = '';
      createForm.requireAudit = true;
      availableDetails.value = [];
      availableTotal.value = 0;
      availablePagination.current = 1;
      createDialogVisible.value = true;
    }
    async function fetchAvailableDetails(reset = false) {
      if (!Number(createForm.referrerId)) {
        ElMessage.warning('请先选择引入人');
        return;
      }
      if (reset) {
        availablePagination.current = 1;
        createForm.selectedDetails = {};
      }
      availableLoading.value = true;
      try {
        const res = await listAvailableWithdrawDetails({
          referrerId: Number(createForm.referrerId),
          keyword: createForm.keyword || undefined,
          pageNum: availablePagination.current,
          pageSize: availablePagination.size
        });
        availableDetails.value = res.records || [];
        availableTotal.value = res.total || 0;
      } catch (error) {
        ElMessage.error('查询可提现账单失败');
        console.error(error);
      } finally {
        availableLoading.value = false;
      }
    }
    function changeAvailablePage(page) {
      if (page < 1) return;
      availablePagination.current = page;
      fetchAvailableDetails();
    }
    function isCreateSelected(id) {
      return !!createForm.selectedDetails[id];
    }
    function toggleAvailableDetail(item) {
      const id = item.commissionDetailId;
      if (!id) return;
      const next = {
        ...createForm.selectedDetails
      };
      if (next[id]) {
        delete next[id];
      } else {
        next[id] = item;
      }
      createForm.selectedDetails = next;
    }
    function toggleAllAvailable(event) {
      const next = {
        ...createForm.selectedDetails
      };
      if (event.target.checked) {
        availableDetails.value.forEach(item => {
          if (item.commissionDetailId) next[item.commissionDetailId] = item;
        });
      } else {
        availableDetails.value.forEach(item => {
          delete next[item.commissionDetailId];
        });
      }
      createForm.selectedDetails = next;
    }
    async function handleSubmitCreate() {
      if (!canSubmitCreate.value) return;
      try {
        await createWithdrawByDetails({
          referrerId: Number(createForm.referrerId),
          commissionDetailIds: selectedCreateIds.value,
          expectedAmount: Number(selectedCreateAmount.value.toFixed(2)),
          remark: createForm.remark,
          requireAudit: createForm.requireAudit
        });
        ElMessage.success('提现申请已提交');
        createDialogVisible.value = false;
        fetchWithdrawalList();
      } catch (error) {
        ElMessage.error('提交失败，请重试');
        console.error(error);
      }
    }
    async function handleViewDetail(row) {
      detailDialogVisible.value = true;
      detailLoading.value = true;
      currentRow.value = {
        ...row,
        sourceDetails: [],
        progress: [],
        fundFlows: []
      };
      rejectReason.value = '';
      showRejectInput.value = false;
      try {
        const res = await getWithdrawOrderFullDetail(row.id);
        currentRow.value = {
          ...row,
          ...res,
          sourceDetails: res?.sourceDetails || [],
          progress: res?.progress || [],
          fundFlows: res?.fundFlows || []
        };
      } catch (error) {
        ElMessage.error('获取提现详情失败');
        console.error(error);
      } finally {
        detailLoading.value = false;
      }
    }
    async function handleApprove(row) {
      try {
        await ElMessageBox.confirm(`确认通过引入人“${row.referrerName || row.referrerId}”的提现申请吗？`, '审核确认', {
          confirmButtonText: '确认通过',
          cancelButtonText: '取消',
          type: 'success'
        });
        await auditWithdraw({
          withdrawOrderId: row.id,
          action: 'APPROVE'
        });
        ElMessage.success('已通过');
        fetchWithdrawalList();
      } catch (error) {
        if (error !== 'cancel') ElMessage.error('操作失败');
      }
    }
    async function handleApproveFromDialog() {
      if (!currentRow.value) return;
      await handleApprove(currentRow.value);
      detailDialogVisible.value = false;
    }
    async function handleReject(row) {
      currentRow.value = row;
      rejectReason.value = '';
      showRejectInput.value = true;
    }
    async function confirmReject() {
      if (!currentRow.value) return;
      try {
        await auditWithdraw({
          withdrawOrderId: currentRow.value.id,
          action: 'REJECT',
          rejectReason: rejectReason.value
        });
        ElMessage.success('已拒绝');
        showRejectInput.value = false;
        detailDialogVisible.value = false;
        fetchWithdrawalList();
      } catch (error) {
        ElMessage.error('操作失败');
        console.error(error);
      }
    }
    async function runBatchAudit(action, rejectReasonText) {
      const ids = [...selectedIds.value];
      batchRunning.value = true;
      let success = 0;
      let failed = 0;
      for (const id of ids) {
        try {
          await auditWithdraw({
            withdrawOrderId: id,
            action,
            rejectReason: rejectReasonText
          });
          success += 1;
        } catch (error) {
          failed += 1;
          console.error(`批量审核失败，提现单 ${id}:`, error);
        }
      }
      batchRunning.value = false;
      const actionLabel = action === 'APPROVE' ? '通过' : '驳回';
      if (failed === 0) {
        ElMessage.success(`批量${actionLabel}完成：成功 ${success} 条`);
      } else {
        ElMessage.warning(`批量${actionLabel}完成：成功 ${success} 条，失败 ${failed} 条，请核对后重试`);
      }
      clearSelection();
      fetchWithdrawalList();
    }
    async function handleBatchApprove() {
      if (selectedCount.value === 0) return;
      try {
        await ElMessageBox.confirm(`确认通过所选 ${selectedCount.value} 条提现申请，合计 ¥${formatAmount(selectedTotalAmount.value)} 吗？`, '批量审核确认', {
          confirmButtonText: '确认通过',
          cancelButtonText: '取消',
          type: 'success'
        });
      } catch {
        return;
      }
      await runBatchAudit('APPROVE');
    }
    function openBatchReject() {
      batchRejectReason.value = '';
      batchRejectVisible.value = true;
    }
    async function confirmBatchReject() {
      const reason = batchRejectReason.value.trim();
      if (!reason) {
        ElMessage.warning('请填写驳回原因');
        return;
      }
      batchRejectVisible.value = false;
      await runBatchAudit('REJECT', reason);
    }
    function openManualDialog(row) {
      manualRow.value = row;
      manualRemark.value = row.manualHandleRemark || '';
      manualDialogVisible.value = true;
    }
    async function handleManualComplete() {
      if (!manualRow.value) return;
      try {
        await completeManualWithdraw({
          withdrawOrderId: manualRow.value.id,
          remark: manualRemark.value
        });
        ElMessage.success('人工处理已完成');
        manualDialogVisible.value = false;
        detailDialogVisible.value = false;
        fetchWithdrawalList();
      } catch (error) {
        ElMessage.error('操作失败');
        console.error(error);
      }
    }
    async function handleTimeoutScan() {
      try {
        await ElMessageBox.confirm('确认触发提现超时处理？系统会扫描并处理符合条件的超时订单。', '处理超时单', {
          confirmButtonText: '确认处理',
          cancelButtonText: '取消',
          type: 'warning'
        });
        await handleWithdrawTimeoutOrders();
        ElMessage.success('已触发超时处理');
        fetchWithdrawalList();
      } catch (error) {
        if (error !== 'cancel') ElMessage.error('操作失败');
      }
    }
    function getProgressDotClass(status) {
      const map = {
        COMPLETED: 'bg-emerald-500',
        FAILED: 'bg-red-500',
        PENDING: 'bg-amber-500',
        SKIPPED: 'bg-slate-300'
      };
      return map[status] || 'bg-slate-300';
    }
    onMounted(() => {
      fetchWithdrawalList();
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      return _openBlock(), _createBlock(ListPageShell, {
        fill: ""
      }, {
        header: _withCtx(() => [_createElementVNode("div", {
          class: "list-page-panel is-header-minimal mx-6 pt-6"
        }, [_createElementVNode("div", {
          class: "list-page-heading"
        }, [_cache[32] || (_cache[32] = _createElementVNode("div", {
          class: "list-page-heading-main"
        }, [_createElementVNode("h1", {
          class: "list-page-title"
        }, "提现管理"), _createElementVNode("p", {
          class: "list-page-description"
        }, "审核并处理引入人按账单发起的提现申请，跟踪来源账单、分账进度与失败处理结果。")], -1)), _createElementVNode("div", {
          class: "list-page-heading-actions"
        }, [_createElementVNode("button", {
          class: "btn-secondary inline-flex items-center gap-2",
          onClick: handleTimeoutScan
        }, [...(_cache[30] || (_cache[30] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
        })], -1), _createTextVNode(" 处理超时提现单 ", -1)]))]), _createElementVNode("button", {
          class: "btn-primary inline-flex items-center gap-2",
          onClick: handleCreate
        }, [...(_cache[31] || (_cache[31] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M12 6v6m0 0v6m0-6h6m-6 0H6"
        })], -1), _createTextVNode(" 按账单代发起 ", -1)]))])])])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(PageFilterBar, {
          "shell-class": "filter-bar-shell is-embedded",
          "body-class": "filter-bar-body is-panel",
          "show-refresh": true,
          "refresh-loading": loading.value,
          onRefresh: fetchWithdrawalList
        }, {
          searchActions: _withCtx(() => [_createElementVNode("button", {
            type: "button",
            class: "btn-primary",
            onClick: handleSearch
          }, "搜索"), _createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            onClick: handleReset
          }, "重置")]),
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: filters.status,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => filters.status = $event),
            placeholder: "请选择状态",
            class: "form-select form-control-sm filter-bar-field"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部状态",
              value: undefined
            }), _createVNode(_component_el_option, {
              label: "待审核",
              value: 0
            }), _createVNode(_component_el_option, {
              label: "待执行",
              value: 1
            }), _createVNode(_component_el_option, {
              label: "处理中",
              value: 2
            }), _createVNode(_component_el_option, {
              label: "已到账",
              value: 3
            }), _createVNode(_component_el_option, {
              label: "已驳回",
              value: 4
            }), _createVNode(_component_el_option, {
              label: "失败",
              value: 5
            })]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_select, {
            modelValue: filters.manualHandleStatus,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => filters.manualHandleStatus = $event),
            placeholder: "请选择处理状态",
            class: "form-select form-control-sm filter-bar-field"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部处理状态",
              value: undefined
            }), _createVNode(_component_el_option, {
              label: "无需处理",
              value: 0
            }), _createVNode(_component_el_option, {
              label: "待人工处理",
              value: 1
            }), _createVNode(_component_el_option, {
              label: "已人工处理",
              value: 2
            })]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_select, {
            modelValue: filters.referrerId,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => filters.referrerId = $event),
            placeholder: "搜索引入人姓名",
            filterable: "",
            remote: "",
            clearable: "",
            class: "form-select form-control-sm filter-bar-field",
            "remote-method": searchReferrers,
            loading: referrerLoading.value
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(referrerOptions.value, referrer => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: referrer.id,
                label: referrer.name,
                value: referrer.id
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", null, _toDisplayString(referrer.name), 1), referrer.phone ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(referrer.phone), 1)) : _createCommentVNode("", true)])]),
                _: 2
              }, 1032, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue", "loading"]), _createVNode(_component_el_date_picker, {
            modelValue: filters.dateRange,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => filters.dateRange = $event),
            type: "daterange",
            "range-separator": "至",
            "start-placeholder": "开始日期",
            "end-placeholder": "结束日期",
            format: "YYYY-MM-DD",
            "value-format": "YYYY-MM-DD",
            class: "filter-bar-field is-wide form-date form-control-sm"
          }, null, 8, ["modelValue"])]),
          _: 1
        }, 8, ["refresh-loading"]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("table", _hoisted_6, [_createElementVNode("thead", _hoisted_7, [_createElementVNode("tr", null, [_createElementVNode("th", _hoisted_8, [_createElementVNode("input", {
          type: "checkbox",
          class: "form-check",
          checked: allEligibleSelected.value,
          disabled: eligibleRows.value.length === 0,
          "aria-label": "全选待审核提现单",
          onChange: toggleSelectAll
        }, null, 40, _hoisted_9)]), _cache[33] || (_cache[33] = _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "提现单号", -1)), _cache[34] || (_cache[34] = _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "引入人", -1)), _cache[35] || (_cache[35] = _createElementVNode("th", {
          class: "data-table-th text-right"
        }, "提现金额", -1)), _cache[36] || (_cache[36] = _createElementVNode("th", {
          class: "data-table-th text-center"
        }, "来源账单", -1)), _cache[37] || (_cache[37] = _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "提现状态", -1)), _cache[38] || (_cache[38] = _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "通道状态", -1)), _cache[39] || (_cache[39] = _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "人工处理", -1)), _cache[40] || (_cache[40] = _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "失败信息", -1)), _cache[41] || (_cache[41] = _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "申请时间", -1)), _cache[42] || (_cache[42] = _createElementVNode("th", {
          class: "data-table-th text-center data-table-sticky-right data-table-sticky-head data-table-sticky-action"
        }, "操作", -1))])]), _createElementVNode("tbody", null, [loading.value ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(5, n => {
          return _createElementVNode("tr", {
            key: n,
            class: "animate-pulse"
          }, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(11, m => {
            return _createElementVNode("td", {
              key: m,
              class: _normalizeClass(["data-table-td", m === 11 ? 'data-table-sticky-right data-table-sticky-action' : ''])
            }, [_createElementVNode("div", {
              class: _normalizeClass(["h-4 bg-slate-200 rounded", m === 3 ? 'w-16 ml-auto' : 'w-24'])
            }, null, 2)], 2);
          }), 64))]);
        }), 64)) : tableData.value.length === 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [...(_cache[43] || (_cache[43] = [_createElementVNode("td", {
          colspan: "11",
          class: "data-table-empty"
        }, [_createElementVNode("div", {
          class: "flex flex-col items-center"
        }, [_createElementVNode("svg", {
          class: "w-12 h-12 text-slate-300 mb-3",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
        })]), _createElementVNode("span", {
          class: "text-slate-500"
        }, "暂无提现记录")])], -1)]))])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tableData.value, row => {
          return _openBlock(), _createElementBlock("tr", {
            key: row.id,
            class: "data-table-row"
          }, [_createElementVNode("td", _hoisted_11, [row.status === 0 ? (_openBlock(), _createElementBlock("input", {
            key: 0,
            type: "checkbox",
            class: "form-check",
            checked: selectedIds.value.has(row.id),
            "aria-label": "选择该提现单",
            onChange: $event => toggleRowSelection(row)
          }, null, 40, _hoisted_12)) : _createCommentVNode("", true)]), _createElementVNode("td", _hoisted_13, [_createElementVNode("span", _hoisted_14, _toDisplayString(row.withdrawNo), 1)]), _createElementVNode("td", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, _toDisplayString(row.referrerName?.charAt(0) || 'U'), 1), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_18, _toDisplayString(row.referrerName || '-'), 1), _createElementVNode("div", _hoisted_19, "ID: " + _toDisplayString(row.referrerId || '-'), 1)])])]), _createElementVNode("td", _hoisted_20, [_createElementVNode("span", _hoisted_21, "¥" + _toDisplayString(formatAmount(row.amount)), 1)]), _createElementVNode("td", _hoisted_22, [_createElementVNode("span", _hoisted_23, _toDisplayString(row.sourceDetailCount || row.detailIds?.length || 0) + " 笔 ", 1)]), _createElementVNode("td", _hoisted_24, [_createElementVNode("span", {
            class: _normalizeClass(["status-badge", statusMap[row.status]?.class || statusMap.default.class])
          }, [_createElementVNode("span", {
            class: _normalizeClass(["w-1.5 h-1.5 rounded-full mr-1", statusMap[row.status]?.dot || statusMap.default.dot])
          }, null, 2), _createTextVNode(" " + _toDisplayString(row.statusName || statusMap[row.status]?.label || '未知'), 1)], 2)]), _createElementVNode("td", _hoisted_25, [_createElementVNode("div", _hoisted_26, _toDisplayString(row.channelStatusName || channelStatusMap[row.channelStatus] || row.channelStatus || '-'), 1)]), _createElementVNode("td", _hoisted_27, [_createElementVNode("span", {
            class: _normalizeClass(["status-badge", manualHandleMap[row.manualHandleStatus]?.class || manualHandleMap.default.class])
          }, _toDisplayString(row.manualHandleStatusName || manualHandleMap[row.manualHandleStatus]?.label || '无需处理'), 3)]), _createElementVNode("td", _hoisted_28, [row.latestFailStage || row.latestFailReason ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, _toDisplayString(row.latestFailStage || '失败'), 1), _createElementVNode("div", {
            class: "text-xs text-slate-500 truncate",
            title: row.latestFailReason
          }, _toDisplayString(row.latestFailReason || '-'), 9, _hoisted_31)])) : (_openBlock(), _createElementBlock("span", _hoisted_32, "-"))]), _createElementVNode("td", _hoisted_33, _toDisplayString(row.createTime || '-'), 1), _createElementVNode("td", _hoisted_34, [_createElementVNode("div", _hoisted_35, [row.status === 0 ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "table-action-button is-success",
            title: "通过",
            "aria-label": "通过",
            onClick: $event => handleApprove(row)
          }, [...(_cache[44] || (_cache[44] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M5 13l4 4L19 7"
          })], -1)]))], 8, _hoisted_36)) : _createCommentVNode("", true), row.status === 0 ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "table-action-button is-danger",
            title: "拒绝",
            "aria-label": "拒绝",
            onClick: $event => handleReject(row)
          }, [...(_cache[45] || (_cache[45] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))], 8, _hoisted_37)) : _createCommentVNode("", true), row.manualHandleStatus === 1 ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            class: "table-action-button is-warning",
            title: "完成人工处理",
            "aria-label": "完成人工处理",
            onClick: $event => openManualDialog(row)
          }, [...(_cache[46] || (_cache[46] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9 12l2 2 4-4m5-2a9 9 0 11-18 0 9 9 0 0118 0z"
          })], -1)]))], 8, _hoisted_38)) : _createCommentVNode("", true), _createElementVNode("button", {
            class: "table-action-button is-primary",
            title: "查看详情",
            "aria-label": "查看详情",
            onClick: $event => handleViewDetail(row)
          }, [...(_cache[47] || (_cache[47] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
          }), _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
          })], -1)]))], 8, _hoisted_39)])])]);
        }), 128))])])])]), _createVNode(AppPagination, {
          class: "pagination-bridge",
          pagination: pagination,
          total: total.value,
          "page-sizes": [10, 20, 50],
          onPageChange: handlePageChange,
          onSizeChange: handlePageSizeChange
        }, null, 8, ["pagination", "total"]), selectedCount.value > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_40, [_createElementVNode("div", _hoisted_41, [_createElementVNode("span", _hoisted_42, "已选 " + _toDisplayString(selectedCount.value) + " 条待审核", 1), _createElementVNode("span", _hoisted_43, [_cache[48] || (_cache[48] = _createTextVNode("合计 ", -1)), _createElementVNode("span", _hoisted_44, "¥" + _toDisplayString(formatAmount(selectedTotalAmount.value)), 1)])]), _createElementVNode("div", _hoisted_45, [_createElementVNode("button", {
          type: "button",
          class: "btn-secondary",
          disabled: batchRunning.value,
          onClick: clearSelection
        }, "清空", 8, _hoisted_46), _createElementVNode("button", {
          type: "button",
          class: "btn-danger-secondary",
          disabled: batchRunning.value,
          onClick: openBatchReject
        }, "批量驳回", 8, _hoisted_47), _createElementVNode("button", {
          type: "button",
          class: "btn-primary",
          disabled: batchRunning.value,
          onClick: handleBatchApprove
        }, _toDisplayString(batchRunning.value ? '处理中...' : '批量通过'), 9, _hoisted_48)])])) : _createCommentVNode("", true)]), (_openBlock(), _createBlock(_Teleport, {
          to: "body"
        }, [_createVNode(AppModal, {
          visible: createDialogVisible.value,
          size: "5xl",
          onClose: _cache[12] || (_cache[12] = $event => createDialogVisible.value = false)
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_49, [_cache[50] || (_cache[50] = _createElementVNode("div", null, [_createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900"
          }, "按账单代发起提现"), _createElementVNode("p", {
            class: "text-sm text-slate-500"
          }, "先选择引入人，再勾选可提现账单后提交；提现金额由所选账单合计得出，无需手动填写。")], -1)), _createElementVNode("button", {
            class: "p-1.5 text-slate-400 hover:text-slate-600",
            onClick: _cache[4] || (_cache[4] = $event => createDialogVisible.value = false)
          }, [...(_cache[49] || (_cache[49] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_50, [_createElementVNode("div", _hoisted_51, [_createElementVNode("div", null, [_cache[51] || (_cache[51] = _createElementVNode("label", {
            class: "form-label"
          }, [_createTextVNode("引入人 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _createVNode(_component_el_select, {
            modelValue: createForm.referrerId,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => createForm.referrerId = $event),
            placeholder: "搜索引入人姓名",
            filterable: "",
            remote: "",
            clearable: "",
            class: "form-select w-full",
            "remote-method": searchReferrers,
            loading: referrerLoading.value
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(referrerOptions.value, referrer => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: referrer.id,
                label: referrer.name,
                value: referrer.id
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_52, [_createElementVNode("span", null, _toDisplayString(referrer.name), 1), referrer.phone ? (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString(referrer.phone), 1)) : _createCommentVNode("", true)])]),
                _: 2
              }, 1032, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue", "loading"])]), _createElementVNode("div", null, [_cache[52] || (_cache[52] = _createElementVNode("label", {
            class: "form-label"
          }, "账单关键词", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => createForm.keyword = $event),
            type: "text",
            placeholder: "账单号/订单号/客户",
            class: "form-input w-full"
          }, null, 512), [[_vModelText, createForm.keyword]])]), _createElementVNode("div", _hoisted_54, [_createElementVNode("button", {
            class: "btn-secondary w-full",
            onClick: _cache[7] || (_cache[7] = $event => fetchAvailableDetails(true))
          }, "搜索可提现账单")]), _createElementVNode("div", _hoisted_55, [_cache[53] || (_cache[53] = _createElementVNode("div", {
            class: "text-xs text-primary-700 mb-1"
          }, "已选提现合计", -1)), _createElementVNode("div", _hoisted_56, "¥" + _toDisplayString(formatAmount(selectedCreateAmount.value)), 1), _createElementVNode("div", _hoisted_57, _toDisplayString(selectedCreateIds.value.length) + " 笔账单", 1)])]), _createElementVNode("div", _hoisted_58, [_createElementVNode("table", _hoisted_59, [_createElementVNode("thead", _hoisted_60, [_createElementVNode("tr", null, [_createElementVNode("th", _hoisted_61, [_createElementVNode("input", {
            type: "checkbox",
            class: "form-check",
            checked: allAvailableSelected.value,
            onChange: toggleAllAvailable
          }, null, 40, _hoisted_62)]), _cache[54] || (_cache[54] = _createElementVNode("th", {
            class: "data-table-th text-left"
          }, "账单", -1)), _cache[55] || (_cache[55] = _createElementVNode("th", {
            class: "data-table-th text-left"
          }, "订单/客户", -1)), _cache[56] || (_cache[56] = _createElementVNode("th", {
            class: "data-table-th text-right"
          }, "佣金毛额", -1)), _cache[57] || (_cache[57] = _createElementVNode("th", {
            class: "data-table-th text-right"
          }, "税费", -1)), _cache[58] || (_cache[58] = _createElementVNode("th", {
            class: "data-table-th text-right"
          }, "可提现", -1)), _cache[59] || (_cache[59] = _createElementVNode("th", {
            class: "data-table-th text-left"
          }, "结算时间", -1))])]), _createElementVNode("tbody", null, [availableLoading.value ? (_openBlock(), _createElementBlock("tr", _hoisted_63, [...(_cache[60] || (_cache[60] = [_createElementVNode("td", {
            colspan: "7",
            class: "data-table-empty"
          }, "加载中...", -1)]))])) : availableDetails.value.length === 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_64, [...(_cache[61] || (_cache[61] = [_createElementVNode("td", {
            colspan: "7",
            class: "data-table-empty"
          }, "暂无可提现账单", -1)]))])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableDetails.value, item => {
            return _openBlock(), _createElementBlock("tr", {
              key: item.commissionDetailId,
              class: "data-table-row"
            }, [_createElementVNode("td", _hoisted_65, [_createElementVNode("input", {
              type: "checkbox",
              class: "form-check",
              checked: isCreateSelected(item.commissionDetailId),
              onChange: $event => toggleAvailableDetail(item)
            }, null, 40, _hoisted_66)]), _createElementVNode("td", _hoisted_67, [_createElementVNode("div", _hoisted_68, _toDisplayString(item.billingNo || item.billingId || '-'), 1), _createElementVNode("div", _hoisted_69, "明细ID: " + _toDisplayString(item.commissionDetailId), 1)]), _createElementVNode("td", _hoisted_70, [_createElementVNode("div", _hoisted_71, _toDisplayString(item.orderNo || item.orderId || '-'), 1), _createElementVNode("div", _hoisted_72, _toDisplayString(item.customerName || '-'), 1)]), _createElementVNode("td", _hoisted_73, "¥" + _toDisplayString(formatAmount(item.commissionAmount)), 1), _createElementVNode("td", _hoisted_74, "¥" + _toDisplayString(formatAmount(item.taxAmount)), 1), _createElementVNode("td", _hoisted_75, "¥" + _toDisplayString(formatAmount(item.withdrawableAmount)), 1), _createElementVNode("td", _hoisted_76, _toDisplayString(item.settleTime || '-'), 1)]);
          }), 128))])])]), _createElementVNode("div", _hoisted_77, [_createElementVNode("button", {
            class: "btn-secondary",
            disabled: availablePagination.current <= 1,
            onClick: _cache[8] || (_cache[8] = $event => changeAvailablePage(availablePagination.current - 1))
          }, "上一页", 8, _hoisted_78), _createElementVNode("span", _hoisted_79, "第 " + _toDisplayString(availablePagination.current) + " 页，共 " + _toDisplayString(availableTotal.value) + " 条", 1), _createElementVNode("button", {
            class: "btn-secondary",
            disabled: availableDetails.value.length >= availableTotal.value,
            onClick: _cache[9] || (_cache[9] = $event => changeAvailablePage(availablePagination.current + 1))
          }, "下一页", 8, _hoisted_80)]), _createElementVNode("div", null, [_cache[62] || (_cache[62] = _createElementVNode("label", {
            class: "form-label"
          }, "备注", -1)), _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => createForm.remark = $event),
            rows: "3",
            placeholder: "可选填写备注信息",
            class: "form-textarea w-full resize-none"
          }, null, 512), [[_vModelText, createForm.remark]])])]), _createElementVNode("div", _hoisted_81, [_createElementVNode("button", {
            class: "btn-secondary",
            onClick: _cache[11] || (_cache[11] = $event => createDialogVisible.value = false)
          }, "取消"), _createElementVNode("button", {
            class: "btn-primary",
            disabled: !canSubmitCreate.value,
            onClick: handleSubmitCreate
          }, "提交提现申请", 8, _hoisted_82)])]),
          _: 1
        }, 8, ["visible"])])), (_openBlock(), _createBlock(_Teleport, {
          to: "body"
        }, [_createVNode(AppModal, {
          visible: detailDialogVisible.value,
          size: "6xl",
          onClose: _cache[17] || (_cache[17] = $event => detailDialogVisible.value = false)
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_83, [_createElementVNode("div", null, [_cache[63] || (_cache[63] = _createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900"
          }, "提现详情", -1)), _createElementVNode("p", _hoisted_84, _toDisplayString(currentRow.value?.withdrawNo), 1)]), _createElementVNode("div", _hoisted_85, [currentRow.value ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(["status-badge", statusMap[currentRow.value.status]?.class || statusMap.default.class])
          }, _toDisplayString(currentRow.value.statusName || statusMap[currentRow.value.status]?.label), 3)) : _createCommentVNode("", true), _createElementVNode("button", {
            class: "p-1.5 text-slate-400 hover:text-slate-600",
            onClick: _cache[13] || (_cache[13] = $event => detailDialogVisible.value = false)
          }, [...(_cache[64] || (_cache[64] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])])]), _createElementVNode("div", _hoisted_86, [detailLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_87, "加载详情中...")) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createElementVNode("div", _hoisted_88, [_createElementVNode("div", _hoisted_89, [_cache[65] || (_cache[65] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "引入人", -1)), _createElementVNode("div", _hoisted_90, _toDisplayString(currentRow.value?.referrerName || '-'), 1), _createElementVNode("div", _hoisted_91, "ID: " + _toDisplayString(currentRow.value?.referrerId || '-'), 1)]), _createElementVNode("div", _hoisted_92, [_cache[66] || (_cache[66] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "提现金额", -1)), _createElementVNode("div", _hoisted_93, "¥" + _toDisplayString(formatAmount(currentRow.value?.amount)), 1)]), _createElementVNode("div", _hoisted_94, [_cache[67] || (_cache[67] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "实际到账", -1)), _createElementVNode("div", _hoisted_95, "¥" + _toDisplayString(formatAmount(currentRow.value?.actualAmount)), 1)]), _createElementVNode("div", _hoisted_96, [_cache[68] || (_cache[68] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "通道状态", -1)), _createElementVNode("div", _hoisted_97, _toDisplayString(currentRow.value?.channelStatusName || currentRow.value?.channelStatus || '-'), 1)]), _createElementVNode("div", _hoisted_98, [_cache[69] || (_cache[69] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "人工处理", -1)), _createElementVNode("div", _hoisted_99, _toDisplayString(currentRow.value?.manualHandleStatusName || manualHandleMap[currentRow.value?.manualHandleStatus]?.label || '-'), 1)])]), _createElementVNode("section", _hoisted_100, [_createElementVNode("div", _hoisted_101, [_createElementVNode("div", _hoisted_102, [_cache[70] || (_cache[70] = _createElementVNode("div", null, [_createElementVNode("h4", {
            class: "text-sm font-semibold text-slate-900"
          }, "账单处理明细"), _createElementVNode("p", {
            class: "text-xs text-slate-500 mt-1"
          }, "每笔账单独立展示分账结果与提现结果，整体进度仅作辅助参考。")], -1)), _createElementVNode("span", _hoisted_103, _toDisplayString(currentRow.value?.sourceDetails?.length || 0) + " 笔", 1)]), _createElementVNode("div", _hoisted_104, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sourceStatusSummary.value, item => {
            return _openBlock(), _createElementBlock("div", {
              key: item.label,
              class: "rounded-lg border border-slate-100 bg-slate-50 px-3 py-2"
            }, [_createElementVNode("div", _hoisted_105, _toDisplayString(item.label), 1), _createElementVNode("div", {
              class: _normalizeClass(["text-lg font-semibold mt-0.5", item.class])
            }, _toDisplayString(item.count), 3)]);
          }), 128))])]), _createElementVNode("div", _hoisted_106, [_createElementVNode("table", _hoisted_107, [_cache[72] || (_cache[72] = _createElementVNode("thead", {
            class: "data-table-head"
          }, [_createElementVNode("tr", null, [_createElementVNode("th", {
            class: "data-table-th text-left"
          }, "账单/订单"), _createElementVNode("th", {
            class: "data-table-th text-left"
          }, "客户"), _createElementVNode("th", {
            class: "data-table-th text-right"
          }, "佣金毛额"), _createElementVNode("th", {
            class: "data-table-th text-right"
          }, "税费"), _createElementVNode("th", {
            class: "data-table-th text-right"
          }, "提现金额"), _createElementVNode("th", {
            class: "data-table-th text-left min-w-[240px]"
          }, "账单进度"), _createElementVNode("th", {
            class: "data-table-th text-left"
          }, "分账状态"), _createElementVNode("th", {
            class: "data-table-th text-left"
          }, "分账单号"), _createElementVNode("th", {
            class: "data-table-th text-left"
          }, "提现状态"), _createElementVNode("th", {
            class: "data-table-th text-left"
          }, "失败信息"), _createElementVNode("th", {
            class: "data-table-th text-left"
          }, "更新时间")])], -1)), _createElementVNode("tbody", null, [!currentRow.value?.sourceDetails?.length ? (_openBlock(), _createElementBlock("tr", _hoisted_108, [...(_cache[71] || (_cache[71] = [_createElementVNode("td", {
            colspan: "11",
            class: "data-table-empty"
          }, "暂无来源账单明细", -1)]))])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentRow.value.sourceDetails, detail => {
            return _openBlock(), _createElementBlock("tr", {
              key: detail.withdrawDetailId,
              class: "data-table-row"
            }, [_createElementVNode("td", _hoisted_109, [_createElementVNode("div", _hoisted_110, _toDisplayString(detail.billingNo || detail.billingId || '-'), 1), _createElementVNode("div", _hoisted_111, _toDisplayString(detail.orderNo || detail.orderId || '-'), 1)]), _createElementVNode("td", _hoisted_112, _toDisplayString(detail.customerName || '-'), 1), _createElementVNode("td", _hoisted_113, "¥" + _toDisplayString(formatAmount(detail.commissionAmount)), 1), _createElementVNode("td", _hoisted_114, "¥" + _toDisplayString(formatAmount(detail.taxAmount)), 1), _createElementVNode("td", _hoisted_115, "¥" + _toDisplayString(formatAmount(detail.amount)), 1), _createElementVNode("td", _hoisted_116, [_createElementVNode("div", _hoisted_117, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getBillProgressSteps(detail), (step, index) => {
              return _openBlock(), _createElementBlock(_Fragment, {
                key: step.key
              }, [_createElementVNode("div", _hoisted_118, [_createElementVNode("div", {
                class: _normalizeClass(["w-8 h-8 rounded-full flex items-center justify-center text-xs font-semibold border", getBillProgressStepClass(step.status)]),
                title: step.tip
              }, _toDisplayString(index + 1), 11, _hoisted_119), _createElementVNode("div", {
                class: _normalizeClass(["text-xs leading-none whitespace-nowrap", getBillProgressTextClass(step.status)])
              }, _toDisplayString(step.label), 3)]), index < getBillProgressSteps(detail).length - 1 ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["h-px w-5", step.status === 'failed' ? 'bg-red-300' : 'bg-slate-200'])
              }, null, 2)) : _createCommentVNode("", true)], 64);
            }), 128))])]), _createElementVNode("td", _hoisted_120, _toDisplayString(detail.separateStatusName || '-'), 1), _createElementVNode("td", _hoisted_121, [_createElementVNode("div", _hoisted_122, _toDisplayString(detail.separateNo || '-'), 1), _createElementVNode("div", _hoisted_123, _toDisplayString(detail.outSeparateNo || detail.separateOrderId || '-'), 1)]), _createElementVNode("td", _hoisted_124, _toDisplayString(displayWithdrawStatusName(detail)), 1), _createElementVNode("td", _hoisted_125, [detail.failStage || detail.failReason ? (_openBlock(), _createElementBlock("div", _hoisted_126, [_createElementVNode("div", _hoisted_127, _toDisplayString(detail.failStageName || detail.failStage), 1), _createElementVNode("div", {
              class: "text-xs text-slate-500 truncate",
              title: detail.failReason
            }, _toDisplayString(detail.failReason || '-'), 9, _hoisted_128)])) : (_openBlock(), _createElementBlock("span", _hoisted_129, "-"))]), _createElementVNode("td", _hoisted_130, _toDisplayString(detail.updateTime || detail.createTime || '-'), 1)]);
          }), 128))])])])]), _createElementVNode("section", _hoisted_131, [_createElementVNode("div", _hoisted_132, [_cache[73] || (_cache[73] = _createElementVNode("div", {
            class: "mb-4"
          }, [_createElementVNode("h4", {
            class: "text-sm font-semibold text-slate-900"
          }, "提现单整体进度"), _createElementVNode("p", {
            class: "text-xs text-slate-500 mt-1"
          }, " 账单级分账和提现结果以上方账单处理明细为准。 ")], -1)), !currentRow.value?.progress?.length ? (_openBlock(), _createElementBlock("div", _hoisted_133, "暂无整体进度")) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentRow.value.progress, node => {
            return _openBlock(), _createElementBlock("div", {
              key: node.nodeCode,
              class: "flex gap-3 pb-4 last:pb-0"
            }, [_createElementVNode("div", {
              class: _normalizeClass(["mt-1 w-2.5 h-2.5 rounded-full", getProgressDotClass(node.status)])
            }, null, 2), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_134, _toDisplayString(node.nodeName), 1), _createElementVNode("div", _hoisted_135, _toDisplayString(node.description || '-'), 1), _createElementVNode("div", _hoisted_136, _toDisplayString(node.time || '-'), 1)])]);
          }), 128))]), _createElementVNode("div", _hoisted_137, [_cache[74] || (_cache[74] = _createElementVNode("h4", {
            class: "text-sm font-semibold text-slate-900 mb-4"
          }, "资金流水", -1)), !currentRow.value?.fundFlows?.length ? (_openBlock(), _createElementBlock("div", _hoisted_138, "暂无资金流水")) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentRow.value.fundFlows, flow => {
            return _openBlock(), _createElementBlock("div", {
              key: flow.id || `${flow.bizType}-${flow.createTime}`,
              class: "flex justify-between gap-4 py-2 border-b border-slate-100 last:border-b-0"
            }, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_139, _toDisplayString(flow.actionTypeName || flow.actionType || flow.flowTypeName || '资金变动'), 1), _createElementVNode("div", _hoisted_140, _toDisplayString(flow.bizNo || flow.remark || '-'), 1)]), _createElementVNode("div", _hoisted_141, [_createElementVNode("div", _hoisted_142, "¥" + _toDisplayString(formatAmount(flow.changeAmount || flow.amount)), 1), _createElementVNode("div", _hoisted_143, _toDisplayString(flow.createTime || '-'), 1)])]);
          }), 128))])]), currentRow.value?.manualHandleRemark || currentRow.value?.rejectReason || currentRow.value?.auditRemark ? (_openBlock(), _createElementBlock("section", _hoisted_144, [_cache[78] || (_cache[78] = _createElementVNode("h4", {
            class: "text-sm font-semibold text-slate-900 mb-3"
          }, "处理备注", -1)), _createElementVNode("div", _hoisted_145, [currentRow.value?.auditRemark ? (_openBlock(), _createElementBlock("div", _hoisted_146, [_cache[75] || (_cache[75] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "审核备注", -1)), _createElementVNode("div", _hoisted_147, _toDisplayString(currentRow.value.auditRemark), 1)])) : _createCommentVNode("", true), currentRow.value?.rejectReason ? (_openBlock(), _createElementBlock("div", _hoisted_148, [_cache[76] || (_cache[76] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "驳回原因", -1)), _createElementVNode("div", _hoisted_149, _toDisplayString(currentRow.value.rejectReason), 1)])) : _createCommentVNode("", true), currentRow.value?.manualHandleRemark ? (_openBlock(), _createElementBlock("div", _hoisted_150, [_cache[77] || (_cache[77] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "人工处理备注", -1)), _createElementVNode("div", _hoisted_151, _toDisplayString(currentRow.value.manualHandleRemark), 1)])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)], 64))]), _createElementVNode("div", _hoisted_152, [currentRow.value?.manualHandleStatus === 1 ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn-secondary",
            onClick: _cache[14] || (_cache[14] = $event => openManualDialog(currentRow.value))
          }, "完成人工处理")) : _createCommentVNode("", true), currentRow.value?.status === 0 ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "btn-danger-secondary",
            onClick: _cache[15] || (_cache[15] = $event => showRejectInput.value = true)
          }, "拒绝")) : _createCommentVNode("", true), currentRow.value?.status === 0 ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            class: "btn-primary",
            onClick: handleApproveFromDialog
          }, "通过")) : _createCommentVNode("", true), _createElementVNode("button", {
            class: "btn-secondary",
            onClick: _cache[16] || (_cache[16] = $event => detailDialogVisible.value = false)
          }, "关闭")])]),
          _: 1
        }, 8, ["visible"])])), (_openBlock(), _createBlock(_Teleport, {
          to: "body"
        }, [_createVNode(AppModal, {
          visible: showRejectInput.value,
          size: "md",
          "z-index": 60,
          scrollable: false,
          onClose: _cache[21] || (_cache[21] = $event => showRejectInput.value = false)
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_153, [_cache[80] || (_cache[80] = _createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900"
          }, "拒绝原因", -1)), _createElementVNode("button", {
            class: "p-1.5 text-slate-400 hover:text-slate-600",
            onClick: _cache[18] || (_cache[18] = $event => showRejectInput.value = false)
          }, [...(_cache[79] || (_cache[79] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_154, [_withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => rejectReason.value = $event),
            rows: "4",
            placeholder: "请输入拒绝原因",
            class: "form-textarea w-full resize-none"
          }, null, 512), [[_vModelText, rejectReason.value]])]), _createElementVNode("div", _hoisted_155, [_createElementVNode("button", {
            class: "btn-secondary",
            onClick: _cache[20] || (_cache[20] = $event => showRejectInput.value = false)
          }, "取消"), _createElementVNode("button", {
            class: "btn-danger-secondary",
            onClick: confirmReject
          }, "确认拒绝")])]),
          _: 1
        }, 8, ["visible"])])), (_openBlock(), _createBlock(_Teleport, {
          to: "body"
        }, [_createVNode(AppModal, {
          visible: batchRejectVisible.value,
          size: "md",
          "z-index": 60,
          scrollable: false,
          onClose: _cache[25] || (_cache[25] = $event => batchRejectVisible.value = false)
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_156, [_cache[82] || (_cache[82] = _createElementVNode("h3", {
            id: "batch-reject-title",
            class: "text-lg font-semibold text-slate-900"
          }, "批量驳回", -1)), _createElementVNode("button", {
            class: "p-1.5 text-slate-400 hover:text-slate-600",
            "aria-label": "关闭",
            onClick: _cache[22] || (_cache[22] = $event => batchRejectVisible.value = false)
          }, [...(_cache[81] || (_cache[81] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_157, [_createElementVNode("p", _hoisted_158, "以下驳回原因将应用于所选 " + _toDisplayString(selectedCount.value) + " 条提现申请。", 1), _cache[83] || (_cache[83] = _createElementVNode("label", {
            for: "batch-reject-reason",
            class: "form-label"
          }, [_createTextVNode("驳回原因 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _withDirectives(_createElementVNode("textarea", {
            id: "batch-reject-reason",
            "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => batchRejectReason.value = $event),
            rows: "4",
            placeholder: "请输入驳回原因",
            class: "form-textarea w-full resize-none"
          }, null, 512), [[_vModelText, batchRejectReason.value]])]), _createElementVNode("div", _hoisted_159, [_createElementVNode("button", {
            class: "btn-secondary",
            disabled: batchRunning.value,
            onClick: _cache[24] || (_cache[24] = $event => batchRejectVisible.value = false)
          }, "取消", 8, _hoisted_160), _createElementVNode("button", {
            class: "btn-danger-secondary",
            disabled: batchRunning.value,
            onClick: confirmBatchReject
          }, _toDisplayString(batchRunning.value ? '处理中...' : '确认驳回'), 9, _hoisted_161)])]),
          _: 1
        }, 8, ["visible"])])), (_openBlock(), _createBlock(_Teleport, {
          to: "body"
        }, [_createVNode(AppModal, {
          visible: manualDialogVisible.value,
          size: "lg",
          "z-index": 60,
          scrollable: false,
          onClose: _cache[29] || (_cache[29] = $event => manualDialogVisible.value = false)
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_162, [_createElementVNode("div", null, [_cache[84] || (_cache[84] = _createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900"
          }, "完成人工处理", -1)), _createElementVNode("p", _hoisted_163, _toDisplayString(manualRow.value?.withdrawNo), 1)]), _createElementVNode("button", {
            class: "p-1.5 text-slate-400 hover:text-slate-600",
            onClick: _cache[26] || (_cache[26] = $event => manualDialogVisible.value = false)
          }, [...(_cache[85] || (_cache[85] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_164, [_createElementVNode("div", _hoisted_165, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(manualRiskTips.value, tip => {
            return _openBlock(), _createElementBlock("div", {
              key: tip
            }, _toDisplayString(tip), 1);
          }), 128))]), _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[27] || (_cache[27] = $event => manualRemark.value = $event),
            rows: "4",
            placeholder: "请输入人工处理说明",
            class: "form-textarea w-full resize-none"
          }, null, 512), [[_vModelText, manualRemark.value]])]), _createElementVNode("div", _hoisted_166, [_createElementVNode("button", {
            class: "btn-secondary",
            onClick: _cache[28] || (_cache[28] = $event => manualDialogVisible.value = false)
          }, "取消"), _createElementVNode("button", {
            class: "btn-primary",
            onClick: handleManualComplete
          }, "确认完成")])]),
          _: 1
        }, 8, ["visible"])]))]),
        _: 1
      });
    };
  }
};